package com.schoolconnect.app.feature.eventsnews

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun EventsNewsFeatureRoute(
    schoolId: String,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    val viewModel = remember(schoolId) { EventsNewsViewModel(schoolId) }
    val state by viewModel.uiState.collectAsState()
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    EventsNewsScreen(state, viewModel::onEvent, onBack, shellRoleCode, onChangeRole, onLogout)
}
